import { render, staticRenderFns } from "./InstalacionesCrud.vue?vue&type=template&id=6507777e"
import script from "./InstalacionesCrud.vue?vue&type=script&lang=js"
export * from "./InstalacionesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports